<template>
    <div class="body">
      <div class="header">
        <el-form :model="UvFilelFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>
            <el-button  size="small" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增uv文件"
        :visible.sync="drawer"
        width="25%"
      >
        <el-form
          ref="accountForm"
          :rules="rules"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
          <el-form-item label="文件名称" prop="name">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.name"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 5px" label="绑定面板文件" prop="operator">
          <el-select clearable size="small" v-model="accountForm.panelId" allow-create filterable>
            <el-option
              v-for="item in miniList"
              clearable
              :key="item.fileName"
          :label="item.fileName"
          :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="field102">
          <el-input-number v-model="accountForm.number" placeholder="数量"></el-input-number>
</el-form-item>
<el-form-item label="上传源文件"  class="errorPageImg">

                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/uvFile/uvUpload"

                        name="files"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <img v-if="accountForm.path" :src="accountForm.path"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                </el-form-item>

                <el-form-item label="上传缩略图"  class="errorPageImg">
               <el-upload
                class="avatar-uploader"
                action="api/serviceCenter/uvFile/uploadThumbnail"
                name="files"
                :show-file-list="false"
                :on-success="thumbnailPathSuccess"
                :before-upload="beforeAvatarUpload"
                >
                <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
        <div style="display: flex">

          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <el-dialog title="编辑uv文件" :visible.sync="dialogVisible"  width="25%" :close-on-click-modal="false">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm"
        >
        <el-form-item label="文件名称" prop="name">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.name"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 5px" label="绑定面板文件" prop="operator">
          <el-select clearable size="small" v-model="accountForm.panelId" allow-create filterable>
            <el-option
              v-for="item in miniList"
              clearable
              :key="item.fileName"
          :label="item.fileName"
          :value="item.id"
            />
          </el-select>
        </el-form-item>
          <el-form-item label="数量" prop="field102">
          <el-input-number v-model="accountForm.number" placeholder="数量"></el-input-number>
          </el-form-item>
          <el-form-item label="上传源文件"  class="errorPageImg">

                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/uvFile/uvUpload"

                        name="files"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload1"
                        >
                        <img v-if="accountForm.path" :src="accountForm.path"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                </el-form-item>

                <el-form-item label="上传缩略图"  class="errorPageImg">
               <el-upload
                class="avatar-uploader"
                action="api/serviceCenter/uvFile/uploadThumbnail"
                name="files"
                :show-file-list="false"
                :on-success="thumbnailPathSuccess"
                :before-upload="beforeAvatarUpload"
                >
                <img v-if="accountForm.thumbnailPath" :src="accountForm.thumbnailPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>

      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="uploadTime"
            align="center"
            label="上传时间"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="文件名称"
          ></el-table-column>
          <el-table-column
    prop="thumbnailPath"
    label="缩略图"
    align="center"
    width="200" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnailPath"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnailPath" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
<el-table-column
            prop="number"
            align="center"
            label="数量"
          ></el-table-column>
               <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </template>

  <script>
  import { addUvFile,upDateUvFile ,UvFileSelectInfo,bathDeleteFile,uvSelectPanel} from '@/api/order/uvFile.js'
  export default {
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        date: '',
        conTract: [],
        UvFilelFindDTO:{
            startTime: '',
            endTime: '',
            deliveryMethod: '',
            access:''
        },
        drawer: false,
        dialogVisible:false,
        miniList:[],
        accountForm:{
          id:'',
          access:'',
          number:'1',
          name:'',
          panelId:'',
          path:'',
          thumbnail:''
        },
        miniFindDTO:{
          access:''
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        rules:{
          //  deliveryMethod:
          //  [
               //     { required: true, message: '请输入发货方式', trigger: 'blur' }]
            }
      }
    },
    mounted() {
      this.UvFilelFindDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getMiniList()
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      getMiniList(){
        this.miniFindDTO.access=localStorage.getItem("access")
        uvSelectPanel(this.miniFindDTO).then((res) => {
          this.miniList = res.data.data
          console.log(this.miniList)
         // this.total = Number(res.data.data.total)
        })
      },
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      getTableData() {
        UvFileSelectInfo(this.currentPage, this.pageSize, this.UvFilelFindDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },

      handleAvatarSuccess(res, file) {
        this.accountForm.path = res.data.ori_file[0];
      },
      thumbnailPathSuccess(res, file){
        this.accountForm.thumbnailPath = res.data.ori_file[0];
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addUvFile(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',

              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传缩略图图片只能是 JPG/PNG/JPEG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传缩略图大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      beforeAvatarUpload1(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过 20MB!');
        }
        return  isLt20M;
      },
   //修改
   editAccount() {
    upDateUvFile(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteFile(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.UvFilelFindDTO.startTime = e[0]
          this.UvFilelFindDTO.endTime = e[1]
        } else if (!e) {
          this.UvFilelFindDTO.startTime = ''
          this.UvFilelFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },

    }
  }
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
  }
  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
